import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { changePassword } from "../services/changePassword";

export default function ChangePassword() {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate(); 

    
    const handleSubmit = async(e) =>{
        try {
            e.preventDefault()
            if (password === confirmPassword){
                const response =  await changePassword(password,token)
                if(response.success){
                    alert('Contraseña cambiada con exito')
                    navigate('/eventos')
                }
            }else {
                alert('Las contraseñas no coinciden')
            }
            
        } catch (error) {
            console.log(error)
            alert('No se pudo cambiar la contraseña, intentelo mas tarde')
        }

    }

    return (
        <div className="h-screen">
            <form className="flex flex-col max-w-sm m-auto mt-3 space-y-4 p-4 font-sans" onSubmit={handleSubmit}>
                <label htmlFor="">Nueva contraseña</label>
                <input
                    className="p-2 rounded-lg bg-zinc-800"
                    type="password"
                    name="password"
                    id="password"
                    value={password}
                    placeholder="Contraseña"
                    onChange={(e)=> setPassword(e.target.value) }
                    />
                <label htmlFor="">Repetir contraseña</label>
                <input
                    className="p-2 rounded-lg bg-zinc-800"
                    type="password"
                    name="confirmpassword"
                    id="confirmpassword"
                    value={confirmPassword}
                    placeholder="Repetir contraseña"
                    onChange={(e)=> setConfirmPassword(e.target.value) }
                />
                <button className="bg-yellow-cdg hover:bg-yellow-600 text-black p-3 rounded-lg">Enviar</button>
            </form>
        </div>
    );
}
